import React, {useEffect} from 'react';
import {useState} from 'react';
import {formatBytes} from '../../Constants/Functions';
import {CONFIG_CONSTANT} from '../../Constants/ConfigsConstants';
import TextInput from '../../UI/Form/TextInput';
import TextArea from '../../UI/Form/TextArea';
import {ICONS} from '../../Constants/Icons';
import {getDigitalProduct} from '../functions/getDigitalProduct';
import {useLocale} from '../../Localization/LocaleContext';

const AddDigitalProduct = ({
  digitalProducts,
  setDigitalProducts,
  isEdit,
  listingId,
}) => {
  const {translate: t} = useLocale();
  //destructure
  const {account_id, title, description, version_name, active} =
    digitalProducts;
  const content = digitalProducts?.content ?? [];

  // File Upload part
  const handleFileClick = () => {
    document.getElementById('select-digital-product-file').click();
  };

  //selectFile
  const selectFile = e => {
    setDigitalProducts({
      ...digitalProducts,
      content: [
        ...content,
        {
          upload_file: true,
          full_file: e.target.files[0],
          size: formatBytes(e.target.files[0].size),
          mime_type: e.target.files[0].type,
          file_name: e.target.files[0].name.replace(/\s/g, '-'),
        },
      ],
    });
  };

  // deleteContent
  const deleteContent = item => {
    setDigitalProducts({
      ...digitalProducts,
      content: content.filter(
        it => it.file_name != item.file_name && it.size != item.size,
      ),
    });
  };

  useEffect(() => {
    if (isEdit && listingId) {
      getDigitalProduct({listingId: listingId}).then(res => {
        if (res && Object.keys(res).length > 0) {
          setDigitalProducts(res);
        }
      });
    }
  }, [isEdit, listingId]);

  return (
    <div className="w-full bg-[var(--color-surface)]  p-4  min-h-min flex flex-col gap-6 rounded-[5px]      border border-SimonGray">
      <div className="flex items-center justify-between">
        <h3 className=" font-semibold text-primary text-xl  text-start">
          {t('listings.digital_product.title', 'Add Digital Product')}
        </h3>
        <button
          className="btn-primary-outline"
          onClick={() => handleFileClick()}>
          {t('listings.digital_product.select_file', 'Select file')}
        </button>
        <input
          type="file"
          value={''}
          id={'select-digital-product-file'}
          className="h-0  opacity-0  w-0 absolute"
          multiple={false}
          onChange={selectFile}
        />
      </div>

      {/* Upload digital product file  */}

      {/* Contents list */}
      {content?.length > 0 && (
        <div className="flex flex-col gap-4 ">
          {content?.map(item => {
            return (
              <div className="w-full flex items-center justify-start gap-3 rounded-card shadow-sm border border-primary p-2">
                <span className=" flex -none text-primary">
                  {ICONS.file_icon}
                </span>
                <p className=" flex-grow text-base text-gray-600 font-medium max-w-4/5 truncate">
                  {item.file_name}
                </p>
                <button
                  className="text-primary hover:text-error  flex-none "
                  onClick={() => deleteContent(item)}>
                  {ICONS.delete_icon}
                </button>
              </div>
            );
          })}
        </div>
      )}

      {/* Input fields */}
      <div className="flex flex-col gap-4">
        {CONFIG_CONSTANT.LISTINGS_CONFIGS?.digital_content?.title !== false && (
          <TextInput
            title={t('listings.digital_product.name', 'Title')}
            current_data={title}
            placeholder={t('listings.digital_product.name', 'Title')}
            type={'text'}
            update_data={data =>
              setDigitalProducts({
                ...digitalProducts,
                title: data,
              })
            }
            isRequired={true}
          />
        )}
        {CONFIG_CONSTANT.LISTINGS_CONFIGS?.digital_content?.version !==
          false && (
          <TextInput
            title={t('listings.digital_product.version', 'Version')}
            current_data={version_name}
            placeholder={t('listings.digital_product.version', 'Version')}
            type={'text'}
            update_data={data =>
              setDigitalProducts({
                ...digitalProducts,
                version_name: data,
              })
            }
            isRequired={true}
          />
        )}

        {CONFIG_CONSTANT.LISTINGS_CONFIGS?.digital_content?.description !==
          false && (
          <TextArea
            title={t('listings.digital_product.description', 'Description')}
            current_data={description}
            placeholder={t('listings.digital_product.description', 'Description')}
            type={'text'}
            update_data={data =>
              setDigitalProducts({
                ...digitalProducts,
                description: data,
              })
            }
          />
        )}
      </div>
    </div>
  );
};

export default AddDigitalProduct;
